import Disciplines from '../enums/Disciplines';

export const emptyFilter = {
    page: 0,
    pageSize: 20,
    disciplines: Object.values(Disciplines).map(dis => {
        return {
            value: dis,
            show: true
        };
    }),
    sortBy: {
        id: 'date',
        desc: true
    }
};

export const initialLoaderState = {
    members: [],
    times: [],
    filter: emptyFilter
};

export default function trainingReducer(state = initialLoaderState, action = {
    members: [],
    trainings: [],
    selection: undefined,
    trainers: [],
    courseSetter: undefined,
    shareToken: undefined
}) {
    if (action.type === 'ADD_TRAINING') {
        return {
            ...state,
            trainings: [...state.trainings, action.data]
        };
    } else if (action.type === 'SELECT_TRAINING') {
        return {
            ...state,
            selection: state.trainings[action.data]
        };
    } else if (action.type === 'SET_TRAINING') {
        return {
            ...state,
            selection: action.data
        };
    } else if (action.type === 'SET_TRAINING_SHARE_TOKEN') {
        return {
            ...state,
            shareToken: action.data
        };
    } else if (action.type === 'CLEAR_TRAININGS') {
        return {
            ...state,
            trainings: []
        };
    } else if (action.type === 'SET_TRAINERS') {
        return {
            ...state,
            trainers: action.data
        };
    } else if (action.type === 'SET_COURSE_SETTER') {
        return {
            ...state,
            courseSetter: action.data
        };
    } else if (action.type === 'RESET_OVERVIEW_FILTER') {
        return {
            ...state,
            filter: emptyFilter
        };
    } else if (action.type === 'SET_OVERVIEW_FILTER') {
        const newFilter = JSON.parse(JSON.stringify(state.filter));
        if (action.data.type) {
            if (action.data.type === 'discipline') {
                if (action.data.value === 'all') {
                    newFilter.disciplines.forEach(disc => disc.show = true);
                } else if (action.data.value === 'none') {
                    newFilter.disciplines.forEach(disc => disc.show = false);
                } else {
                    if (action.data.value.id < newFilter.disciplines.length) {
                        newFilter.disciplines[action.data.value.id].show = !newFilter.disciplines[action.data.value.id].show;
                    }
                }
            } else {
                newFilter[action.data.type] = action.data.value;
            }
        }
        return {
            ...state,
            filter: newFilter
        };
    }

    return state;
}
